import request from '@/utils/request'

// Login method
export function login(username, password) {
  return request({
    url: '/auth/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: { username, password }
  })
}

// Get verification code image
export function getCodeImg() {
  return request({
    url: '/captcha',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// Registration method
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data: {
      username: data.phone,
      password: data.password,
      code: data.verificationCode,
      phonenumber: data.phone,
      appType: 'deepark' // Set app type for Deepark users
    }
  })
}

// Token refresh method
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// Get user information
export function getUserInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// Logout method
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

// Reset password
export function resetPassword(data) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data
  })
}

// Send verification code
export function sendVerificationCode(data) {
  return request({
    url: '/auth/verification-code',
    method: 'post',
    data
  })
}

// Send SMS verification code
export function sendSmsCode(phone) {
  return request({
    url: '/auth/sms-send',
    method: 'post',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    data: { username: phone }
  })
}

// Login with SMS code
export function loginWithSmsCode(phone, code,msgId) {
  return request({
    url: '/auth/sms-loginx',
    method: 'post',
    headers: {
      isToken: false
    },
    data: { phone: phone, code: code ,msgId:msgId}
  })
}


// Login with WeChat code
export function loginWithWechatCode(code, options = {}) {
  return request({
    url: '/auth/wechat-login',
    method: 'post',
    headers: {
      isToken: false,
      skipErrorMessage: options.silent === true
    },
    data: { code: code }
  })
}

/** 已登录用户绑定微信（需携带 token） */
export function bindWechat(code) {
  return request({
    url: '/auth/bind-wechat',
    method: 'post',
    data: { code }
  })
}

/** 已登录用户绑定手机号（需携带 token） */
export function bindPhone(phone, code, msgId) {
  return request({
    url: '/auth/bind-phone',
    method: 'post',
    data: { phone, code, msgId }
  })
}


